import React, { useEffect, useState } from 'react';
import { Avatar, Box, Tooltip, useTheme } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { COLORS } from '../../theme';
import { resolveAvatar } from '../../utils/avatar';
import AvatarPickerDialog from './AvatarPickerDialog';

// Avatar do cliente com a ação de troca acoplada.
// Sempre exibe um avatar (inclusive para contas sem avatar salvo, via
// fallback determinístico) e, quando `editable`, abre o seletor ao clicar.
const UserAvatarButton = ({
  usuario,
  size = 46,
  editable = false,
  onAvatarUpdated,
  badgeSize = 20,
  badgeBorderColor,
  avatarSx = {},
  containerSx = {},
}) => {
  const theme = useTheme();
  const [pickerOpen, setPickerOpen] = useState(false);
  const [imageFailed, setImageFailed] = useState(false);

  const avatar = resolveAvatar(usuario);
  const initial = usuario?.nome?.trim()?.charAt(0)?.toUpperCase() || 'Z';
  const canEdit = editable && typeof onAvatarUpdated === 'function';
  const borderColor = badgeBorderColor || theme.palette.background.paper;

  useEffect(() => {
    setImageFailed(false);
  }, [avatar]);

  const avatarElement = (
    <Avatar
      src={imageFailed ? undefined : avatar}
      alt={usuario?.nome || 'Cliente'}
      onError={() => setImageFailed(true)}
      sx={{
        width: size,
        height: size,
        bgcolor: COLORS.orange,
        color: COLORS.white,
        fontWeight: 800,
        fontSize: Math.round(size * 0.4),
        ...avatarSx,
      }}
    >
      {initial}
    </Avatar>
  );

  if (!canEdit) {
    return <Box sx={{ display: 'inline-flex', ...containerSx }}>{avatarElement}</Box>;
  }

  return (
    <>
      <Tooltip title="Alterar avatar" arrow>
        <Box
          component="button"
          type="button"
          onClick={() => setPickerOpen(true)}
          aria-label="Alterar avatar"
          sx={{
            position: 'relative',
            display: 'inline-flex',
            border: 0,
            p: 0,
            bgcolor: 'transparent',
            cursor: 'pointer',
            borderRadius: '50%',
            lineHeight: 0,
            '&:hover .user-avatar-edit-badge': {
              bgcolor: COLORS.orangeDeep,
            },
            '&:focus-visible': {
              outline: `2px solid ${COLORS.orange}`,
              outlineOffset: 3,
            },
            ...containerSx,
          }}
        >
          {avatarElement}

          <Box
            className="user-avatar-edit-badge"
            sx={{
              position: 'absolute',
              right: Math.round(badgeSize * -0.2),
              bottom: Math.round(badgeSize * -0.2),
              width: badgeSize,
              height: badgeSize,
              borderRadius: '50%',
              bgcolor: COLORS.orange,
              color: COLORS.white,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: `2px solid ${borderColor}`,
              transition: 'background-color 0.2s ease',
            }}
          >
            <Edit sx={{ fontSize: Math.round(badgeSize * 0.6) }} />
          </Box>
        </Box>
      </Tooltip>

      <AvatarPickerDialog
        open={pickerOpen}
        onClose={() => setPickerOpen(false)}
        currentAvatar={usuario?.avatar || null}
        onSaved={onAvatarUpdated}
      />
    </>
  );
};

export default UserAvatarButton;
